export const legal_structure = [
	{ label: 'Sole Proprietorship', value: 'SOLE' },
	{ label: 'Partnership', value: 'PARTNERSHIP' },
	{ label: 'Corporate', value: 'CORPORATE' },
	{ label: 'Others', value: 'OTHERS' },
];
